export default "__VITE_ASSET__CLuiMSzj__"